import React from 'react';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  getSignInPanel,
  getSignUpPanel,
  getTitlePanel,
  getContactEditBtn,
  getGustUserButtonTemplate,
  getEnterContactDetailsButtonTemplate,
  getEnterContactDetailsTemplate,
} from '../sharedTemplates/CheckoutContactInfoViewTemplates';
import { CATERING } from 'common/constants/SharedConstants';
import FormComponent from 'atoms/FormComponent';

const CheckoutContactInfoView = props => {
  const {
    checkoutDetails,
    signInBtnClickHandler,
    signUpBtnClickHandler,
    updateCheckoutDetails,
    displayFor = null,
  } = props;

  return (
    <div className='checkoutContactInfoContainer'>
      <div className={`row row-cols-12 mt-10px`}>
        {getTitlePanel(
          displayFor === CATERING
            ? translateWithI18Next(TRANSLATE_MAPPING_KEY?.SOMEONE_ELSE_COLLECTING_ORDER)
            : translateWithI18Next(TRANSLATE_MAPPING_KEY?.SIGN_IN_TO_YOUR_ACCOUNT),
          null,
          `${checkoutDetails?.isMobile ? 'txt-align-center' : ''} ${displayFor === CATERING ? CATERING : ''}`,
        )}

        <div className={`contactInfoContent  col-sm-8 col-12`}>
          {displayFor !== CATERING &&
            getSignInPanel(checkoutDetails?.userParams, signInBtnClickHandler, 'contactInfo-button-checkout col-12')}
          {displayFor !== CATERING &&
            checkoutDetails?.showSignUpBtn &&
            getSignUpPanel({
              userParams: checkoutDetails?.userParams,
              signUpBtnClickHandler: signUpBtnClickHandler,
              btnClassName: 'contactInfo-button-checkout col-12',
            })}
          {displayFor !== CATERING && getGustUserButtonTemplate(props)}
          {displayFor === CATERING &&
            !checkoutDetails?.isCateringSomeOneElseContactDetailsEnabled &&
            getEnterContactDetailsButtonTemplate(props, 'col-12')}
          {displayFor === CATERING &&
            checkoutDetails?.isCateringSomeOneElseContactDetailsEnabled &&
            getEnterContactDetailsTemplate(props)}
        </div>
      </div>

      {/* Form Componet render */}
      {checkoutDetails?.isEnableGustUser && displayFor !== CATERING && (
        <div className={`row row-cols-12`}>
          {getTitlePanel(translateWithI18Next(TRANSLATE_MAPPING_KEY?.CONTINUE_AS_A_GUEST), null, 'mt-0px-imp')}
          {checkoutDetails?.guestCheckoutFormConfig?.fieldsConfig?.length && (
            <div className='mt-4 contactInfoContent col-12 col-sm-7 d-flex'>
              <div className={`col-12 ${checkoutDetails?.isMobile ? 'editForm' : ''}`}>
                <FormComponent
                  formConfig={{
                    ...checkoutDetails?.guestCheckoutFormConfig,
                    checkoutDetails, // optional field belogs to checkout page
                    updateCheckoutDetails, // optional field belogs to checkout page
                  }}
                />
              </div>
              {checkoutDetails?.paymentEnabled &&
                checkoutDetails?.isClickAddPayment &&
                getContactEditBtn({
                  checkoutDetails,
                  updateCheckoutDetails,
                  className: 'mt-0px-imp float-right',
                })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(CheckoutContactInfoView);
